

import { ThemeEvents, CartUpdateEvent } from '@theme/events';
// --- Helper to get a block by its ID ---
function getBlockById(id) {
  return window.qnaData.find(b => b && b.id === id);
}

// --- Holds [{ blockId, chosen }] for user answers ---
let qnaChosenPath = [];
window.answers = [];

// --- Core rendering function using block id navigation ---
function renderQna() {
    if (!window.qnaData) {
        return; 
    }

  const QnAflow = document.querySelector('#qna-quiz');
  let html = '';
  let step = 0;

  // Start from the first block (the first id in your window.qnaData array)
  let currentBlockId = window.qnaData[0]?.id;
  let ended = false;

  // Follow the path by block id, not index!
  while (currentBlockId && !ended) {
    const block = getBlockById(currentBlockId);
    if (!block) break;
    const stepInfo = qnaChosenPath[step] || {};

    // --- QnA "question" block ---
    if (block.type === "question") {
      const optionsHtml = block.answers.filter(a => a.text).map((ans, idx) => `
        <button class="quiz-option qna-option ${stepInfo.chosen == idx ? ' selected' : ''}"
                data-step-idx="${step}" data-answer-idx="${idx}" data-block-id="${block.id}">
          ${ans.photo ? `<img class='qna-product-choice' src="${ans.photo}" alt="${ans.text}"  />` : ""}
          <h3 class='qna-image-text'> ${ans.label}</h3>
        </button>
      `).join('');
      html += `
        <div class="qna-step quiz-block" data-step-idx="${step}">
          <h4>${block.question}</h4>
          ${block.answerheader ? `<p class="quiz-note">${block.answerheader}</p>` : ''}
          <div class="qna-options quiz-options">${optionsHtml}</div>
        </div>
      `;
      // If an answer was chosen for this step, find the next block id using the chosen answer's goto:
      if (typeof stepInfo.chosen === "number") {
        const gotoId = block.answers[stepInfo.chosen]?.goto;
        if (gotoId) {
          currentBlockId = gotoId;
          step++;
        } else {
          // No goto: stop quiz here
          ended = true;
        }
      } else {
        break;
      }
    }
    // --- Product Card Block ---
    else if (block.type === "product_card") {
      html += `
        <div class="qna-step quiz-block " data-step-idx="${step}">
          <h4>${block.question}</h4>
          ${block.answerheader ? `<p class="quiz-note">${block.answerheader}</p>` : ''}
          <div class="qna-product-options quiz-options" id="qna-product-options-${block.id} ">
            ${block.products.filter(p => p.handle).map((p, i) => `
              <div class="  quiz-option"
                   data-product-handle='${p.handle}'
                   data-product-quantity='${p.quantity}'
                   data-product-subsid='${p.subscription_id}'
                   data-block-id="${block.id}" 
                   data-prod-idx="${i}">
                ${p.photo ? `<div 
                  data-product-handle='${p.handle}'
                   data-product-quantity='${p.quantity}'
                   data-product-subsid='${p.subscription_id}'
                   data-block-id="${block.id}" 
                   data-prod-idx="${i}"
                   class='qna-product-choice' 
                  >
                  <img class='product-card-img' src="${p.photo}" alt="${p.handle}"/>
                   <h3 class='qna-image-text'> ${p.label}</h3>
                   <div class='qna-product-all-price'> <span class='original-price'> ${p.original_price}</span> <span class='discounted-price'> ${p.discounted_price}</span> </div>
                   <div class='qna-product-save-price-text'> ${p.saved_price_text}</div> </div>` : ''}
              </div>
            `).join('')}
          </div>
        </div>
      `;
      ended = true; // End quiz after product selection
    }
    // --- Add more block types here if needed ---
    else {
      break;
    }

  }

  QnAflow.innerHTML = html;

  // --- Click handler for QnA options (answers) ---
  document.querySelectorAll('.qna-option').forEach(option => {
    option.onclick = function () {
      const stepIdx = parseInt(option.getAttribute('data-step-idx'));
      const answerIdx = parseInt(option.getAttribute('data-answer-idx'));
      const blockId = option.getAttribute('data-block-id');
        const productdetailblock = document.querySelector('#qna-quiz-product-details');

         const prodHeader = document.querySelector('.selelcted-prod-header');
        productdetailblock.innerHTML = '';
        if(prodHeader) prodHeader.classList.add('hidden')

      // Find the chosen answer's text:
      const block = getBlockById(blockId);
      const answerText = block.answers[answerIdx]?.text || '';
      // If already chosen, ignore
      if (qnaChosenPath[stepIdx]?.chosen === answerIdx) return;
      // Set this answer, remove anything after
      qnaChosenPath = qnaChosenPath.slice(0, stepIdx);
      window.answers = window.answers.slice(0, stepIdx);
      qnaChosenPath[stepIdx] = {
        blockId: blockId,
        question: block.question,
        chosen: answerIdx
      };
      window.answers[stepIdx] = answerText.toLowerCase();
      renderQna();
      setTimeout(() => {
        const nextBlock = document.querySelector(`.qna-step[data-step-idx="${stepIdx + 1}"]`);
        if (nextBlock) scrollToElement(nextBlock);
      }, 100);
    };
  });
}

// --- Product selection click handler ---
// document.addEventListener('click', function (e) {
//   console.log('qna product click button')
//   console.log('target also checking',e.target.classList)
//   if (e.target.closest('.qna-product-choice')) {
//     console.log('0000000000000000000000000000000000000000')
//     const prodDetail = e.target;
//     const producthandle = prodDetail.getAttribute('data-product-handle');
//     const subscriptionId = prodDetail.getAttribute('data-product-subsid');
//     const quantity = prodDetail.getAttribute('data-product-quantity');
//       console.log('sbuscription id',subscriptionId)
//     fetchProduct(producthandle, subscriptionId, quantity);
//   }
// });

document.addEventListener('click', (e) => {
  const choice = e.target.closest('.qna-product-choice');
  if (!choice) return;

  const producthandle = choice.getAttribute('data-product-handle');
  const subscriptionId = choice.getAttribute('data-product-subsid');
  const quantity = choice.getAttribute('data-product-quantity');

  fetchProduct(producthandle, subscriptionId, quantity);

});


function scrollToElement(el) {
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

function fetchProduct(handle, current_frequency, quantity) {
  const existingProduct = document.getElementById('product-display');
  if (existingProduct) existingProduct.remove();
  fetch(`/products/${handle}.js`)
    .then((res) => res.json())
    .then((product) => {
      displayProduct(product, handle, current_frequency, quantity);
    })
    .catch((err) => {
      console.error('Error fetching product:', err);
    });
}

function displayProduct(product, handle, current_frequency, quantity) {
  const productdetailblock = document.querySelector('#qna-quiz-product-details');
  const sellingPlanIds = product.selling_plan_groups.flatMap(group =>
    group.selling_plans.map(plan => plan.id)
  );
  const singleSellingplanId = current_frequency;
  const basePrice = product.variants[0].price / 100;
  const matchedPlan = product.selling_plan_groups.find(group =>
    group.selling_plans.some(plan => plan.id == singleSellingplanId)
  );
  let discountedPrice = 0;
  let discountPercentage = 0;
  let current_upfront_quantity = quantity;
  if (matchedPlan) {
    const priceAdjustment = matchedPlan.selling_plans[0].price_adjustments[0];
    discountPercentage = parseFloat(priceAdjustment.value);
    discountedPrice = basePrice * (1 - discountPercentage / 100);
  }
  const productBlock = document.createElement('div');
  productBlock.id = 'product-display';
  productBlock.className = 'product-block';
  let priceHTML = "";
  if (discountedPrice > 0) {
    const originalTotal = basePrice * current_upfront_quantity;
    const discountedTotal = discountedPrice * current_upfront_quantity;
    priceHTML = `
      <p><strong>Price:</strong> 
        <strike>£${originalTotal.toFixed(2)}</strike> 
        <strong>£${discountedTotal.toFixed(2)}</strong> 
        <span>(£${discountedPrice.toFixed(2)} per box)</span>
      </p>
    `;
  } else {
    const totalPrice = basePrice * current_upfront_quantity;
    priceHTML = `<p><strong>Price:</strong> £${totalPrice.toFixed(2)}</p>`;
  }
  productBlock.innerHTML = `
    <h4>${product.title}</h4>
    <div class="product-content">
      <div class="product-image">
        <img src="${product.images[0]}" alt="${product.title}" >
      </div>
      <div class="product-details">
        ${priceHTML}
        <p>${product.description}</p>
        <button class="add-to-cart-final button button--primary" 
                data-handle="${product.handle}" 
                data-variant-id="${product.variants[0].id}">
          Add To Basket
        </button>
      </div>
    </div>
  `;
   const product_list_wrapper = document.querySelector('.qna-quiz-product-details-wrapper');
    scrollToElement(product_list_wrapper);
  const addToCartBtn = productBlock.querySelector('.add-to-cart-final');
  addToCartBtn.addEventListener('click', () => {
    addToCartBtn.textContent = 'Adding...';
    prodaddToCartByHandle(handle, quantity, singleSellingplanId,addToCartBtn);
  });
      const prodHeader = document.querySelector('.selelcted-prod-header');

  productdetailblock.innerHTML = '';
  prodHeader.classList.add('hidden')
  if (productdetailblock) {
    productdetailblock.appendChild(productBlock);
      if(prodHeader)
      { 
        prodHeader.classList.remove('hidden')
      }
  }
}

 function prodaddToCartByHandle(handle, quantity, subscriptionID,addToCartBtn) {
  const cartdrawer = document.querySelector('cart-drawer');
  fetch(`/products/${handle}.js`)
    .then((res) => res.json())
    .then((product) => {
      const variantId = product.variants[0].id;
      const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const subscriptionDay = window.answers.find((ans) => dayNames.includes(ans)) || 'Not specified';
      const subcritpiondayformated = subscriptionDay.charAt(0).toUpperCase() + subscriptionDay.slice(1).toLowerCase();
      const formData = {
        items: [
          {
            id: variantId,
            quantity: quantity ? quantity : 1,
            selling_plan: subscriptionID,
            sections_url: window.location.pathname,
            properties: {
              _subscription: 'Yes',
              _subscription_day: subcritpiondayformated,
              _upfrontboxes: quantity,
            },
          },
        ],
      };
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    })
    .then((response) => response.json())
    .then((data) => {
           addToCartBtn.textContent ='Added'

        //  document.addEventListener(ThemeEvents.cartUpdate, cartUpdate);
        document.dispatchEvent(
      new CartUpdateEvent(data, 'add-to-cart-btn', {
        source: 'product-form',
        productId: data.items[0].product_id, 
        variantId: data.items[0].id,        
        itemCount: data.item_count,        
      })
    );
    setTimeout(()=>{ 
     addToCartBtn.textContent ='Add To Basket'
    },600)
    })
    .catch((err) => {
      console.error('Add to cart error:', err);
      alert('Something went wrong. Try again.');
    });
};




// --- Run the quiz on page load ---
document.addEventListener('DOMContentLoaded', function () {
  qnaChosenPath = [];
  window.answers = [];
  renderQna();
});


// PRODUCT RECOMMENDATIONS CAROUSEL JS SLIDER STUDIO 61 //
document.addEventListener("DOMContentLoaded", function () {

  const DEBUG = true;
  const MAX_RETRIES = 3;
  let retries = 0;

  function log(...args) {
    if (DEBUG) console.log("[Carousel Debug]:", ...args);
  }

  function init() {
    const carousel = document.querySelector(".resource-list__carousel");

    if (!carousel) {
      if (retries >= MAX_RETRIES) {
        log("Carousel not found. Stopping after 3 attempts.");
        return;
      }

      retries++;
      log(`Carousel not found. Retrying (${retries}/${MAX_RETRIES})…`);
      return setTimeout(init, 300);
    }

    const slidesContainer = carousel.querySelector("slideshow-slides");
    const arrows = carousel.querySelector("slideshow-arrows");

    if (!slidesContainer) {
      if (retries >= MAX_RETRIES) {
        log("slidesContainer not found. Stopping after 3 attempts.");
        return;
      }

      retries++;
      log(`slidesContainer not found. Retrying (${retries}/${MAX_RETRIES})…`);
      return setTimeout(init, 300);
    }

    if (!arrows) {
      log("arrows not found.");
      return;
    }

    log("Carousel found:", carousel);
    log("Slides container:", slidesContainer);
    log("Arrows container:", arrows);

    function getSlideCount() {
      const count = slidesContainer.querySelectorAll("slideshow-slide").length;
      log("Real slide count:", count);
      return count;
    }

    function updateCarouselUI() {
      const slideCount = getSlideCount();

      // REMOVE ARROWS IF < 3 SLIDES
      if (slideCount < 3 && arrows.isConnected) {
        arrows.remove();
        log("Removed arrows (<3 slides)");
      }

      // UPDATE CURSOR STYLE
      slidesContainer.style.cursor = slideCount < 3 ? "auto" : "grab";
    }

    // Run now
    updateCarouselUI();

    // Observe dynamic slide changes
    const observer = new MutationObserver(() => {
      log("Mutation detected → updating UI");
      updateCarouselUI();
    });

    observer.observe(slidesContainer, { childList: true, subtree: true });

    log("MutationObserver attached.");
  }

  init();
});



/* main delivery information box hide if empty */
document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector("#product-date");
  if (!target) return;

  function evaluateDateVisibility() {
    const hasAvailableLabel = target.querySelector(".available-label");
    
    if (!hasAvailableLabel) {
      target.style.display = "none";
      console.log("[Delivery Date] Hidden — No available-label found");
    } else {
      target.style.display = "";
      console.log("[Delivery Date] Visible — available-label detected");
    }
  }

  // Run immediately
  evaluateDateVisibility();

  // Watch for dynamic Shopify updates (AJAX, variant change, section re-render)
  const observer = new MutationObserver(() => {
    evaluateDateVisibility();
  });

  observer.observe(target, { childList: true, subtree: true });
});